export const domainsNotAllowIndex = [
  /** INFO: uat domains */
  'https://uat-sg-proxy.omc.osim.com',
  'https://uat-my-proxy.omc.osim.com',
  'https://uat-hk-proxy.omc.osim.com',
  'https://uat-tw-proxy.omc.osim.com',
  'https://uat-th-proxy.omc.osim.com',
  /** INFO: pre-prod domains */
  'https://preprod-sg-proxy.omc.osim.com',
  'https://preprod-my-proxy.omc.osim.com',
  'https://preprod-hk-proxy.omc.osim.com',
  'https://preprod-tw-proxy.omc.osim.com',
  'https://preprod-th-proxy.omc.osim.com',
  /** INFO: prod domains */
  'https://prod-sg-cd.omc.osim.com',
  'https://prod-my-cd.omc.osim.com',
  'https://prod-hk-cd.omc.osim.com',
  'https://prod-tw-cd.omc.osim.com',
  'https://prod-th-cd.omc.osim.com'
];